<template>
  <v-card class="elevation-12">
    <v-toolbar dark color="primary">
      <v-toolbar-title>{{$t('LoginPage.PasswordForm.header')}}</v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-card-text>
      <v-form>
        <v-text-field 
          id="password" 
          prepend-icon="lock" 
          name="password" 
          :label="$t('LoginPage.Form.password')" 
          type="password" 
          v-model="password" 
          @keyup.enter="login"
        >
        </v-text-field>
        <v-text-field 
          id="confirmPassword" 
          prepend-icon="lock" 
          name="confirmPassword" 
          :label="$t('LoginPage.Form.confirmPassword')" 
          type="password" 
          v-model="confirmPassword" 
          @keyup.enter="submitPassword"
          :rules="[() => (this.confirmPassword === this.password) || $t('LoginPage.PasswordForm.notSame')]"
        >
        </v-text-field>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn 
        text
        color="grey" 
        @click="$emit('cancel')" 
      >
        {{$t('Global.Action.cancel')}}
      </v-btn>
      <v-btn  
        color="primary" 
        :loading="loading" 
        @click="submitPassword" 
        :disabled="!validForm"
      >
        {{$t('Global.Action.confirm')}}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import usersApi from '@/services/users'
export default {
  name: 'TheNewPasswordForm',
  data: () => ({
    loading: false,
    password: '',
    confirmPassword: ''
  }),
  computed: {
    validForm () {
      return (this.password === this.confirmPassword) && this.password
    }
  },
  methods: {
    async submitPassword () {
      if (this.validForm) {
        this.loading = true
        try {
          await usersApi.newPassword(this.$route.query.token, this.password)
          this.$emit('passwordUpdated')
        } catch (error) {
          this.loading = false
          this.$emit('error', this.$t('LoginPage.Error.updatePassword'))
          throw error
        }
      }
    }
  }
}
</script>